import AlquilerFormulario from '@/pages/Vecino/Alquiler/Formulario';
import AlquilerNuevoVecino from '@/pages/Vecino/Alquiler/NuevoVecino';
import VentaFormulario from '@/pages/Vecino/Venta/Formulario';
import VentaNuevoVecino from '@/pages/Vecino/Venta/NuevoVecino';
import Resident from '@/pages/Vecino/Resident';
import DomicilioAnterior from '@/pages/Vecino/DomicilioAnterior';
import Referencia from '@/pages/Vecino/Referencia';
import Vehiculos from '@/pages/Vecino/Vehiculos';
import TitularPropietario from '@/pages/Vecino/TitularPropietario';
import Success from '@/pages/Vecino/Common/Success';
import TerminosYCondiciones from '@/pages/Vecino/Common/TerminosYCondiciones';
import SuccessProcedure from '@/pages/Vecino/Common/SuccessProcedure';
import Invalid from '@/pages/Vecino/Common/Invalid';
import ErrorServer from '@/pages/Vecino/Common/ErrorServer';

const vecino = [
    {
        path: '/vecino/alquiler/formulario',
        component: AlquilerFormulario
    },
    {
        path: '/vecino/alquiler/nuevoVecino',
        component: AlquilerNuevoVecino
    },
    {
        path: '/vecino/venta/formulario',
        component: VentaFormulario
    },
    {
        path: '/vecino/venta/nuevoVecino',
        component: VentaNuevoVecino
    },
    {
        path: '/vecino/conyugePareja',
        component: Resident
    },
    {
        path: '/vecino/domicilioAnterior/:indexTitular',
        component: DomicilioAnterior
    },
    {
        path: '/vecino/referencia',
        component: Referencia
    },
    {
        path: '/vecino/vehiculos',
        component: Vehiculos
    },
    {
        path: '/vecino/titularPropietario/:indexTitular',
        component: TitularPropietario
    },
    {
        path: '/vecino/terminos-y-condiciones',
        component: TerminosYCondiciones
    },
    {
        path: '/vecino/successProcedure',
        component: SuccessProcedure
    },
    {
        path: '/vecino/success',
        component: Success
    },
    {
        path: '/vecino/invalid',
        component: Invalid
    },
    {
        path: '/vecino/errorServer',
        component: ErrorServer
    }
]




const routes = [
    ...vecino
]

export default routes;